<div class="flex-container" fxLayoutAlign="center center" fxLayoutWrap="wrap">
<div class="timeline w-80 p-relative education mt-5" fxFlex.lg="80%" fxFlex.md="80%" fxFlex.sm="95%">
  <div class="row">
    <div class="col-md-12">
      <div class="curriculum">
        <ng-container *ngIf="course.syllabus; let syllabus">
          <ng-container *ngFor="let curriculumUnit of syllabus.curriculum; index as i">
          <div class="exp" [ngClass]=AppConfig.theme>
            <button mat-icon-button class="p-absolute right-20" (click)="removeCurriculumUnit(i)">
              <mat-icon class="color-gray">delete</mat-icon>
            </button>
              <form class="w-100 title-form" (ngSubmit)="onSubmit(syllabus)">
                <div class="hgroup">
                  <h4>
                    <mat-form-field>
                      <input class="text-left" matInput placeholder="제목을 입력해주세요" [(ngModel)]="curriculumUnit.title" name="title"/>
                    </mat-form-field>
                  </h4>
                  <h6>
                    <mat-form-field>
                    <input class="text-left" matInput placeholder="날짜를 입력해주세요" [(ngModel)]="curriculumUnit.date" name="date"/>
                    </mat-form-field>
                  </h6>
                </div>
                <p>
                  <mat-form-field class="w-100">
                    <textarea placeholder="내용을 입력해주세요" rows="3" matInput [(ngModel)]="curriculumUnit.content" name="content"></textarea>
                  </mat-form-field>
                </p>
              </form>
          </div>
          </ng-container>

          <button mat-fab class="p-relative addButton" color="accent" (click)="addCurriculum()">
            <mat-icon>add</mat-icon>
          </button>

          <button class="p-absolute right-30" mat-raised-button color="accent" type="submit" (click)="onSubmit(syllabus)">저장</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-curriculum-edit/syllabus-curriculum-edit.component.html